import { cn } from '@heidi/utils';

import { focusRing } from '../styles/focus-ring';
import { typographyVariant } from '../typography';

export const dialogOverlayClasses =
  'fixed inset-0 z-50 bg-overlay data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0';

export const dialogContentPositionFixedClasses = 'fixed left-1/2 top-1/2 z-50';

export const dialogContentPositionAbsoluteClasses = 'absolute left-1/2 top-1/2 z-[101]';

export const dialogContentClasses =
  'grid w-full max-w-lg -translate-x-1/2 -translate-y-1/2 gap-4 border border-surface-elevated-border bg-surface-elevated p-6 shadow-dialog duration-200 focus:outline-0 focus-visible:outline-0 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] sm:rounded-2xl';

export const dialogCloseIconClasses = cn(
  'absolute end-4 top-4 rounded-sm opacity-70 transition-opacity hover:opacity-100 disabled:pointer-events-none data-[state=open]:bg-background-secondary data-[state=open]:text-text-secondary',
  focusRing
);

export const dialogHeaderClasses = 'flex flex-col space-y-1.5 text-center sm:text-start';

export const dialogFooterClasses =
  'flex flex-col-reverse sm:flex-row sm:justify-end sm:gap-2';

// Zero specificity so a call site's `truncate` or `text-balance` still wins; plain
// `text-pretty` is emitted after `truncate` and would turn wrapping back on.
export const dialogTitleClasses = cn(
  typographyVariant({ variant: 'h4' }),
  '[:where(&)]:text-pretty'
);

export const dialogDescriptionClasses = cn(
  typographyVariant({ variant: 'p2' }),
  'text-text-secondary',
  '[:where(&)]:text-pretty'
);
